import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfDownloadService {

  constructor(private http: HttpClient) { }

  downloadPdfFromBase64(base64String: string, fileName: string) {
    // Decodifica la stringa Base64 in un array di byte
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Crea un oggetto Blob dal byte array
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Crea un URL dati dal Blob
    const blobUrl = URL.createObjectURL(blob);

    // Scarica il file
    saveAs(blobUrl, fileName);
  }

  // Metodo per scaricare il manuale come Blob
  downloadManual(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/uploaddownload/downloadmanuser`, { responseType: 'blob' });
  }
}


